// Server-side globalIdField (graphql-relay) encodes a node's id as
// base64(`${typeName}:${rawId}`) — see graphql/src/graphql/type/NovaAgentCategoryType.js /
// NovaAgentType.js, and the inverse decode in Util.getUUIdFromBase64String (which does
// atob(str).split(':')[1]). graphql-relay/relay-runtime don't expose an encode helper to the
// client (the former isn't a web-front dependency, the latter's version here doesn't export
// `toGlobalId`), so this re-implements the same encoding for building Relay store record ids
// (e.g. RANGE_ADD's `parentID`) client-side from a known type name + domain id.
export function toRelayGlobalId(typeName: string, rawId: string): string {
	return btoa(`${typeName}:${rawId}`);
}
